<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.css">
    <div>
      <app-breadcrumb></app-breadcrumb>
      <app-notification-message
      [errorMessage]="errorMessage"
      [successMessage]="successMessage"
    >
    </app-notification-message>
    <div *ngIf="errorMessageRemove!=null" class="alert alert-danger alert-dismissible ms-4 me-4 p-2">
        <button type="button" class="btn-close pb-1" (click)="close()" data-bs-dismiss="alert" aria-label="close"></button>
        <!-- <mat-icon style="vertical-align: text-bottom;">thumb_down</mat-icon> &nbsp; -->
        <strong class="ps-2">{{errorMessageRemove}}</strong>
    </div>
    <div *ngIf="errorMessageAdd!=null" class="alert alert-danger alert-dismissible ms-4 me-4 p-2">
        <button type="button" class="btn-close pb-1" (click)="close()" data-bs-dismiss="alert" aria-label="close"></button>
        <!-- <mat-icon style="vertical-align: text-bottom;">thumb_down</mat-icon> &nbsp; -->
        <strong class="ps-2">{{errorMessageAdd}}</strong>
    </div>
      <button type="button" class="roboto-bold" id="btnadd" (click)="addResolutionBtn()">
        <i class="fa fa-plus" aria-hidden="true"></i> Add Resolution</button>
      <h2 class="roboto-medium title ms-4 me-4 mb-1 mt-1">AET Resolution Orders</h2>
    </div>
    <hr>
    <div class="d-flex gap-5 justify-content-between align-items-top ms-4 me-4 mt-2">
        <div class="grid">
            <label> Resolution # </label>
            <span> {{resolutionId}} </span>
            <!-- <span>3252</span> -->
        </div>
        <div class="grid">
            <label> Type </label>
            <span> {{setResolutionType}} </span>
        </div>
        <div class="grid">
            <label> Load Number </label>
            <span> {{loadNumber}} </span>
        </div>
        <div class="grid">
            <label> Destination </label>
            <span class="check"> {{destination}} </span>
        </div>
        <div class="grid">
            <label> ETA </label>
            <span> {{eta}} </span>
        </div>
    </div>
    
    <div class="mt-2 tabStyle">
        <mat-nav-list class="inline">
            <a mat-list-item (click)="removeExisting()" [ngClass]="highlightUnVerified? 'active' : 'inactive' "
                class="menu bar">Remove Existing</a>
            <div class="vr"></div>
            <a mat-list-item (click)="addOrders()" [ngClass]="highlightVerified? 'active' : 'inactive' "
                class="menu bar">Add</a>
        </mat-nav-list>
    </div>
    <hr>

    <div class="mt-2" *ngIf="selectedTab == 'remove'">
        <label class="ms-2"></label>
      <button type="button" (click)="removeBtn()" class="roboto-bold" id="btnremove">
          <i class="fa fa-trash" aria-hidden="true">
          </i> Remove</button>
          <div class="myDiv ms-4 me-4 mt-4">
            <div class="d-flex p-2 ps-3">
                <label><b> RESOLUTION ORDERS </b> </label>
            </div>
        </div>
    <app-addresolutionordersgrid [data]="removeData" (select)="onRemoveOrders($event)"></app-addresolutionordersgrid>
  </div>

  <div class="mt-2" *ngIf="selectedTab == 'add'">
      <label class="ms-2"></label>
    <button type="button" (click)="addBtn()" class="roboto-bold ms-3" id="btnadd">
        <i class="fa fa-plus" aria-hidden="true">
        </i> Add</button>
    <button type="button" (click)="addOrdersGrid()" class="roboto-bold" id="btnsearch">
        <i class="fa fa-search" aria-hidden="true">
        </i> Search</button>
    <div class="ms-4 mt-4">
        <label>Unload</label>
        <input type="date" class="ms-3" [(ngModel)]="unloadDate" onkeypress="return false">
        <label class="ms-5">Route</label>
        <input type="text" class="ms-3" [(ngModel)]="route">
        <label class="ms-5">Supplier</label>
        <input type="text" class="ms-3" [(ngModel)]="supplier">
        <label class="ms-5">Plant</label>
        <select class="ms-3" [(ngModel)]="selectedPlant">
            <!-- <option value="" selected>Please Select a Value</option> -->
            <!-- <option value="tmmk">TMMK</option>
            <option value="tmmi">TMMI</option> -->
            <option *ngFor="let option of dropdownOptionPlant" [value]="option.label">{{ option.value }}
        </select>
        <label class="ms-5">Dock</label>
        <input type="text" class="ms-3" [(ngModel)]="dock">
    </div>
    <div class="myDiv ms-4 me-4 mt-3">
        <div class="d-flex p-2 ps-3">
            <label><b> OWK ORDERS </b> </label>
        </div>
    </div>
  <app-addresolutionordersgrid [data]="addData" (select)="onAddOrders($event)"></app-addresolutionordersgrid>
</div>